import { render, staticRenderFns } from "./LandingSelect.vue?vue&type=template&id=a8aba438&scoped=true&"
import script from "./LandingSelect.vue?vue&type=script&lang=ts&"
export * from "./LandingSelect.vue?vue&type=script&lang=ts&"
import style0 from "./LandingSelect.vue?vue&type=style&index=0&id=a8aba438&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8aba438",
  null
  
)

export default component.exports